import { Component } from '@angular/core';

@Component({
  selector: 'star-icon',
  templateUrl: 'star-icon.html'
})
export class StarIconComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/icons/star-icon/star-icon.ts